module.exports = __webpack_public_path__ + "static/media/first.ea03f24f.jpeg";